import { getAxiosClient, makeApiRequest } from '@givelify/utils';
import { webConfig } from 'webConfig';
import { City } from '../types';

export const getCities = (input: string) => {
    const url = `${webConfig.searchEngineUrl}/autosuggest/city?term=${input}`;
    const httpRequest = getAxiosClient().get(url)
    const result = makeApiRequest<City[]>(httpRequest);
    return result;
};